/* ============================================================
   V2 theme.js — drawer / age gate / LINE / finder / gift / filters
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.MUZI || { lineUrl: 'https://lin.ee/Yqtm3Tz' };

  /* ---------- 1. Mobile drawer ---------- */
  var drawerOpenBtn = document.querySelector('[data-drawer-open]');
  var drawerCloseBtn = document.querySelector('[data-drawer-close]');
  var drawer = document.querySelector('[data-mobile-drawer]');

  if (drawerOpenBtn && drawerCloseBtn && drawer) {
    drawerOpenBtn.addEventListener('click', function () {
      drawer.hidden = false;
      drawerOpenBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
    drawerCloseBtn.addEventListener('click', closeDrawer);
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) closeDrawer();
    });
    function closeDrawer() {
      drawer.hidden = true;
      drawerOpenBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
  }

  /* ---------- 2. Age gate（既有機制） ---------- */
  var AGE_KEY = 'muzi_age_verified_v2';
  try {
    if (localStorage.getItem(AGE_KEY) !== '1') {
      var overlay = document.createElement('div');
      overlay.className = 'muzi-age-overlay';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.innerHTML =
        '<div class="muzi-age-modal">' +
        '<p class="muzi-age-modal__brand">木子</p>' +
        '<p class="muzi-age-modal__text">本網站含酒類商品資訊，請確認您已年滿 18 歲。</p>' +
        '<p class="muzi-age-modal__text">未滿 18 歲請勿瀏覽。</p>' +
        '<div class="muzi-age-modal__actions">' +
        '<button class="muzi-age-btn muzi-age-btn--confirm" id="muziAgeConfirm">我已滿 18 歲</button>' +
        '<a class="muzi-age-btn muzi-age-btn--leave" href="https://www.google.com">離開網站</a>' +
        '</div>' +
        '</div>';
      document.body.appendChild(overlay);
      document.getElementById('muziAgeConfirm').addEventListener('click', function () {
        try { localStorage.setItem(AGE_KEY, '1'); } catch (e) {}
        overlay.remove();
      });
    }
  } catch (e) { /* storage unavailable — skip gate */ }

  /* ---------- 3. Floating LINE button（既有行為） ---------- */
  var lineIcon = document.createElement('button');
  lineIcon.className = 'muzi-line-icon';
  lineIcon.setAttribute('aria-label', 'LINE 詢問');
  /* 2026-09-08 Owner LINE 全站統一：浮動鈕 icon = 金色細線稿 PNG（line-gold-outline-icon.png，同 icon-line.liquid）；
     舊綠底白字 SVG 不再保留；container 尺寸／位置／shadow 由 base.css 控制不變 */
  lineIcon.innerHTML =
    '<img class="muzi-line-icon__img" src="' + (CFG.lineIconImg || '') + '" alt="" width="30" height="30">';
  document.body.appendChild(lineIcon);

  function buildLineUrl(message) {
    var url = CFG.lineUrl || 'https://lin.ee/Yqtm3Tz';
    var msg = message || '';
    if (CFG.lineOaId && CFG.lineOaId.indexOf('@') === 0) {
      url = 'https://line.me/R/oaMessage/' + encodeURIComponent(CFG.lineOaId) + '/?' + encodeURIComponent(msg);
    } else if (msg) {
      url += (url.indexOf('?') > -1 ? '&' : '?') + 'text=' + encodeURIComponent(msg);
    }
    return url;
  }

  lineIcon.addEventListener('click', function () {
    window.open(buildLineUrl('你好，我想詢問清酒～'), '_blank', 'noopener');
  });

  /* ---------- 4. Finder / Gift step forms ---------- */
  function initSteps(root) {
    if (!root) return;
    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    var progress = root.querySelectorAll('[data-progress-item]');
    var nav = root.querySelector('[data-step-nav]');
    var backBtn = root.querySelector('[data-step-back]');
    var nextBtn = root.querySelector('[data-step-next]');
    var summary = root.querySelector('[data-summary]');
    var lineBtn = root.querySelector('[data-line-send]');
    var copyBtn = root.querySelector('[data-line-copy]');
    var current = 0;

    function showStep(i) {
      current = Math.max(0, Math.min(i, steps.length - 1));
      steps.forEach(function (s, idx) { s.classList.toggle('is-active', idx === current); });
      if (progress) progress.forEach(function (p, idx) { p.classList.toggle('is-active', idx <= current); });
      if (nav) nav.classList.toggle('is-step0', current === 0);
      if (backBtn) backBtn.style.visibility = current === 0 ? 'hidden' : 'visible';
      if (nextBtn) {
        var step = steps[current];
        var selected = step.querySelector('.finder-option.is-selected');
        nextBtn.disabled = !selected;
        if (current === steps.length - 1) {
          nextBtn.textContent = '完成';
        } else {
          nextBtn.textContent = '下一步';
        }
      }
    }

    steps.forEach(function (step, idx) {
      step.querySelectorAll('.finder-option').forEach(function (opt) {
        opt.addEventListener('click', function () {
          step.querySelectorAll('.finder-option').forEach(function (o) { o.classList.remove('is-selected'); });
          opt.classList.add('is-selected');
          var nxt = nextBtn;
          if (nxt) nxt.disabled = false;
        });
      });
    });

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var step = steps[current];
        var selected = step.querySelector('.finder-option.is-selected');
        if (!selected) return;
        if (current === steps.length - 1) {
          buildSummary();
        } else {
          showStep(current + 1);
        }
      });
    }
    if (backBtn) {
      backBtn.addEventListener('click', function () { showStep(current - 1); });
    }

    function buildSummary() {
      if (!summary) return;
      var rows = [];
      var lines = [];
      var firstLine = root.getAttribute('data-line-first') || '你好 Chloe，我想找酒：';
      lines.push(firstLine);
      steps.forEach(function (step, idx) {
        var selected = step.querySelector('.finder-option.is-selected');
        var label = step.getAttribute('data-step-label') || ('步驟 ' + (idx + 1));
        var value = selected ? selected.getAttribute('data-value') || selected.getAttribute('data-label') : '';
        var valueLabel = selected ? selected.getAttribute('data-label') || value : '';
        if (selected) {
          rows.push('<div class="finder-summary__row"><span class="finder-summary__key">' + label + '</span><span class="finder-summary__value">' + valueLabel + '</span></div>');
          lines.push(label + '：' + valueLabel);
        }
      });
      lines.push('我已滿 18 歲。');
      summary.querySelector('[data-summary-list]').innerHTML = rows.join('');
      summary.classList.add('is-visible');
      var message = lines.join('\n');
      if (lineBtn) {
        lineBtn.href = buildLineUrl(message);
        lineBtn.classList.add('btn--line');
      }
      if (copyBtn) {
        copyBtn.addEventListener('click', function () {
          var ta = document.createElement('textarea');
          ta.value = message;
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          ta.remove();
          copyBtn.textContent = '已複製';
        });
      }
      summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    showStep(0);
  }

  document.querySelectorAll('[data-finder]').forEach(initSteps);

  /* ---------- 4b. Find Sake 一頁式三 Step（Owner 04-finder 參考圖；[data-finder] 舊 wizard 仍由 gift-wizard 共用）
     契約：三個 [data-finder-group] 同時 render；點選→同組單選→即時更新摘要；三項齊全才啟用 LINE CTA ---------- */
  function initFinderOnePage(root) {
    if (!root) return;
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-finder-group]'));
    var list = root.querySelector('[data-summary-list]');
    var lineBtn = root.querySelector('[data-finder-send]');
    var firstLine = root.getAttribute('data-line-first') || '你好 Chloe，我想找酒：';

    function update() {
      var rows = [];
      var lines = [firstLine];
      var complete = true;
      groups.forEach(function (g) {
        var label = g.getAttribute('data-finder-label') || g.getAttribute('data-finder-group');
        var sel = g.querySelector('.finder-v2__option.is-selected');
        var text = sel ? (sel.getAttribute('data-label') || sel.getAttribute('data-value') || '—') : '—';
        rows.push('<div class="finder-v2__summary-row"><span class="finder-v2__summary-key">' + label + '</span><span class="finder-v2__summary-value' + (sel ? '' : ' is-empty') + '">' + text + '</span></div>');
        if (!sel) {
          complete = false;
        } else {
          lines.push(label + '：' + text);
        }
      });
      if (list) list.innerHTML = rows.join('');
      if (lineBtn) {
        if (complete) {
          lines.push('我已滿 18 歲。');
          lineBtn.href = buildLineUrl(lines.join('\n'));
          lineBtn.classList.remove('is-disabled');
          lineBtn.removeAttribute('aria-disabled');
          lineBtn.removeAttribute('tabindex');
        } else {
          lineBtn.removeAttribute('href');
          lineBtn.classList.add('is-disabled');
          lineBtn.setAttribute('aria-disabled', 'true');
          lineBtn.setAttribute('tabindex', '-1');
        }
      }
    }

    groups.forEach(function (g) {
      g.querySelectorAll('[data-finder-opt]').forEach(function (opt) {
        opt.addEventListener('click', function () {
          g.querySelectorAll('[data-finder-opt]').forEach(function (o) {
            o.classList.remove('is-selected');
            o.setAttribute('aria-pressed', 'false');
          });
          opt.classList.add('is-selected');
          opt.setAttribute('aria-pressed', 'true');
          update();
        });
      });
    });

    update();
  }

  document.querySelectorAll('[data-finder-one-page]').forEach(initFinderOnePage);

  /* ---------- 5. 酒造名／品牌搜尋：精確語法（原生 Shopify field+quoted） ----------
     /collections/all 的搜尋列送出時，把查詢詞包成
       title:"Q" OR vendor:"Q" OR tag:"Q"
     Shopify 原生語法；結果必含完整查詢詞於 title/vendor/tags（實證 7/7/18/0）。
     不清洗括號/引號等搜尋運算子，避免使用者輸入被解讀為搜尋語法。 */
  document.querySelectorAll('[data-search-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var input = form.querySelector('[data-search-input]');
      if (!input) return;
      var raw = (input.value || '').replace(/["()]/g, '').trim();
      if (raw === '') { e.preventDefault(); return; }
      input.value = 'title:"' + raw + '" OR vendor:"' + raw + '" OR tag:"' + raw + '"';
    });
  });

  /* ---------- 5b. How-to-choose 酒類第一層（清酒／利口酒）切換 ---------- */
  var typeSelect = document.querySelector('[data-howto-select]');
  if (typeSelect) {
    typeSelect.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-howto-type]');
      if (!btn) return;
      var kind = btn.getAttribute('data-howto-type');
      typeSelect.querySelectorAll('[data-howto-type]').forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      document.querySelectorAll('[data-howto-panel]').forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-howto-panel') !== kind;
      });
    });
  }

  /* ---------- 6. Product gallery thumbs ---------- */
  var gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    var mainImg = gallery.querySelector('[data-gallery-main]');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-src');
        var alt = thumb.getAttribute('data-alt') || '';
        if (mainImg) mainImg.src = src;
        if (mainImg) mainImg.removeAttribute('srcset');
        if (mainImg) mainImg.alt = alt;
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  }

  /* ---------- 7. Product 幫我比較 → LINE 預填 ---------- */
  document.querySelectorAll('[data-line-compare]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var title = b.getAttribute('data-product-title') || '';
      window.open(buildLineUrl('你好 Chloe，我想比較「' + title + '」與其他類似酒款，請給我建議。'), '_blank', 'noopener');
    });
  });
})();
